export default __webpack_public_path__ + "static/media/ic_lebanon.adad3483.svg";